import React from 'react';
import Icon from '../Icon';

const Menu = (properties) => (
  <Icon
    dPath="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"
    title="Menu"
    fill="var(--grey-dark)"
    {...properties}
  />
);

export default Menu;
